<template>
  <div class="search-bar-component"
       @click="handleClick"
  >
    <span class="text">{{ placeholder }}</span>
    <ym-icon class="icon-search"
              name="search"
    />
  </div>
</template>

<script>
  export default {
    name: 'SearchBar',
    props: {
      placeholder: {
        type: String,
      },
    },
    methods: {
      handleClick() {
        this.$emit('focus');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-bar-component {
    overflow: hidden;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 @search-padding-size;
    height: @search-bar-height;
    border-radius: (@search-bar-height / 2);
    font-size: @font-size-base;
    line-height: 1.2;
    color: @color-text-lighter;
    background-color: @color-gray-lighter;
  }

  .icon-search {
    font-size: 35px;
    color: @color-gray-light;
  }
</style>
